@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-card-alert/lib/index';
@import '~@adv-mt/mt-empty-case-alerts/lib/index';
@import '~@adv-mt/mt-empty-case-default/lib/index';
@import '~@adv-mt/mt-empty-case-favorites/lib/index';
@import '~@adv-mt/mt-list-ads/lib/index';
@import '~@adv-mt/mt-notifications-alert/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@adv-mt/mt-title-user-area/lib/index';

@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-card/lib/index';
@import '~@s-ui/react-atom-image/lib/index';

@import '~@adv-mt/mt-layout-basic/lib/index';

$mh-userTakeOut-page: 380px;

.mt-UserTakeOut {
  min-height: $mh-userTakeOut-page;

  &-title {
    @include media-breakpoint-up(m) {
      margin: $m-xxl 0 $m-l;
    }
    font-size: $fz-xxl;
    font-weight: $fw-regular;
    margin: $m-xl 0 $m-l;
    text-align: center;
  }

  &-subTitle {
    font-size: $fz-m;
    line-height: $lh-xl;
    margin-bottom: $m-xl;
    text-align: center;
  }

  &-listItem {
    @include media-breakpoint-up(m) {
      align-items: center;
      flex-direction: row;
      margin: 0 $m-xxxl * 2 $m-l $m-xxxl * 2;
      text-align: left;
    }
    background: $c-white;
    box-shadow: $bxsh-base;
    display: flex;
    flex-direction: column;
    margin: 0 0 $m-l;
    padding: $p-l;
  }

  &-expiration {
    @include media-breakpoint-up(m) {
      flex: 1;
      justify-content: flex-start;
      margin-bottom: 0;
      padding-left: $p-xxl;
    }
    display: flex;
    justify-content: center;
    margin-bottom: $m-m;
  }

  &-filename {
    @include media-breakpoint-up(m) {
      margin-bottom: 0;
    }
    display: flex;
    font-size: $fz-xl;
    font-weight: $fw-semi-bold;
    justify-content: center;
    margin-bottom: $m-m;
  }

  &-image {
    @include media-breakpoint-up(m) {
      width: 170px;
    }
    display: block;
    margin: 0 auto;
    width: 150px;
  }
}
